<template>
    <div>
        <b-input-group>
            <select2 ref="clientSelect"
                     :id="id"
                     :name="name"
                     :css-class="cssClass"
                     :state="state"
                     :disabled="disabled"
                     placeholder="Select a client"
                     :options="clients"
                     enable-ajax
                     :in-b-modal="inBModal"
                     v-model="currentValue"
                     v-on:search="findClients"
                     v-on:select="clientSelectionChanged"></select2>
        </b-input-group>
        <validation-observer v-slot="{ passes }" slim>
            <b-modal size="md" centered title="New Client" v-model="newClientDialogShown" v-on:ok.prevent="passes(createClient)" v-on:hidden="newClientDialogHidden">
                <b-alert v-model="showErrors" variant="danger" dismissible>
                    <div v-for="(error, index) in currentErrors" :key="index">
                        <p>{{ error }}</p>
                    </div>
                </b-alert>
                <b-form-row>
                    <validation-provider rules="required" name="Name" v-slot="{ valid, errors }" slim>
                        <b-form-group label="Name"
                                      label-for="clientName"
                                      class="col-md-12">
                            <b-form-input name="clientName"
                                          autofocus
                                          v-model="newClient.name"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('email', email);
    localize('en', en);

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import UuidMixins from '../mixins/UuidMixins';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.component('select2', Select2);

    export default {
        name: 'ClientSelect',
        mixins: [ErrorsMixin, UuidMixins],
        model: {
            event: 'change',
            prop: 'value'
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            cssClass: {
                type: String,
                default: 'form-control'
            },
            state: {
                type: Boolean,
                default: null
            },
            initialClients: {
                type: Array,
                default: null
            },
            requiredCourtRegistryId: {
                type: String,
                default: null
            },
            requiredInterviewOrganisationId: {
                type: String,
                default: null
            },
            mandatoryClientProperties: {
                type: Array,
                default: null
            },
            inBModal: {
                type: Boolean,
                default: false
            },
            value: null
        },
        data: function () {
            return {
                currentValue: this.value,
                currentSelectedClients: null,
                newClient: { name: null },
                currentErrors: [],
                newClientDialogShown: false,
                clients: this.initialClients,
            }
        },
        watch: {
            clientId: function () {
                this.clients = null;
                if (this.currentValue != null) {
                    this.currentValue = null;
                    this.currentSelectedClients = null;
                    this.$emit('change', this.currentValue);
                }
            }
        },
        computed: {            
            showErrors: function () {
                return this.currentErrors.length > 0;
            }
        },
        methods: {
            findClients: function(params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined") filter.searchTerm = params.data.term;
                var pathSegments = [];
                if (this.requiredCourtRegistryId) {
                    pathSegments.push("bycourtregistry");
                    pathSegments.push(this.requiredCourtRegistryId);
                } else if (this.requiredInterviewOrganisationId) {
                    pathSegments.push("byintervieworganisation");
                    pathSegments.push(this.requiredInterviewOrganisationId);
                }
                pathSegments.push("find");
                var url = this.$urlHelper.getApiUrl('client', null, pathSegments);
                console.log(url);
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.clientId;
                                obj.text = obj.name;
                                return obj;
                            });
                            mappedData[mappedData.length] = { id: '00000000-0000-0000-0000-000000000000', text: 'New Client' };
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },
            clientSelectionChanged: function() {
                if (this.currentValue == '00000000-0000-0000-0000-000000000000') {
                    this.newClient = { name: null };
                    this.currentErrors = [];
                    this.newClientDialogShown = true;
                } else {
                    this.currentSelectedClients = this.$refs.clientSelect.getSelectedData();
                    this.$emit('change', this.currentValue);
                }
            },
            createClient: function () {
                var url = this.$urlHelper.getApiUrl('client', 'create');
                console.log(url);
                var data = {
                    name: this.newClient.name
                };
                console.log(data);
                this.currentErrors = [];
                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        var newClient = response.data;
                        newClient.id = newClient.clientId;
                        newClient.text = newClient.name;
                        this.$refs.clientSelect.setOptionsAndValue([newClient], newClient.clientId);
                        this.currentValue = newClient.clientId;
                        this.currentSelectedClients = this.$refs.clientSelect.getSelectedData();
                        this.$emit('change', this.currentValue);
                    })
                    .catch(ex => {
                        this.currentErrors = this.handleAxiosException(ex);
                    })
                    .finally(() => {
                        if (this.currentErrors.length == 0) {
                            this.newClientDialogShown = false;
                        }
                    });
            },
            newClientDialogHidden: function () {
                if (this.currentValue == '00000000-0000-0000-0000-000000000000') {
                    this.currentValue = null;
                    this.clientSelectionChanged();
                    this.$refs.clientSelect.focus();
                }
            }
        },
        mounted: function () {
            if (this.currentValue != null) this.currentSelectedClients = this.$refs.clientSelect.getSelectedData();
        }
    }
</script>